//@ts-check
import React, { useRef, useEffect, useState } from "react"
import _ from "lodash"

/**
 * @param fn {()=>void}
 */
export function useRunOnMount(fn) {
  useEffect(fn, [0])
}
export function useRunOnUnmount(fn) {
  useEffect(() => fn, [0])
}
/**
 * Like use state but returns one more function just to toggle
 * @param defaultValue {boolean}
 * @returns {[boolean,(newValue?:boolean)=>void,()=>void]}
 */
export function useToggle(defaultValue) {
  var [value, setValue] = useState(defaultValue)
  function toggle() {
    setValue(!value)
  }
  return [value, setValue, toggle]
}

export function isHigherPermission(requiredPermission, existingPermission) {
  if (existingPermission == "admin") {
    return true
  }
  if (requiredPermission == existingPermission) {
    return true
  }
  return false
}

export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
export async function navigate(url) {
  history.pushState({}, "", url)
  history.back()
  await delay(50)
  history.forward()
}
